var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    clipPath: "url(#camera_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.667 6.984c0-.292 0-.438.012-.561A2.5 2.5 0 0 1 3.92 4.182c.123-.013.277-.013.585-.013.118 0 .177 0 .228-.003a1.67 1.67 0 0 0 1.445-1.042c.02-.046.037-.1.072-.205s.053-.158.072-.205a1.67 1.67 0 0 1 1.445-1.042c.05-.003.106-.003.217-.003h4.032c.11 0 .166 0 .217.003a1.67 1.67 0 0 1 1.445 1.042c.02.047.037.1.072.205.035.106.053.159.072.205.24.598.803 1.003 1.445 1.042.05.003.11.003.228.003.308 0 .462 0 .585.013a2.5 2.5 0 0 1 2.241 2.24c.012.124.012.27.012.562v6.519c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.092c-.535.273-1.235.273-2.635.273H5.667c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.753a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "camera_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .003h20v20H0z"
  })))));
};
export default SvgCamera;